/* eslint-disable max-len */
import * as questionIds from "../../questions/questionIds";

export const skinSectionTwoQuestions = [
    {
        id: questionIds.PaintsAndThinners,
        questionText: "Paints and thinners",
    },
    {
        id: questionIds.LubeOilsGreases,
        questionText: "Lube oils and greases",
    },
    {
        id: questionIds.AdhedivesGlues,
        questionText: "Adhesives and glues",
    },
    {
        id: questionIds.GrindingAbrasives,
        questionText: "Grinding abrasives",
    },
    {
        id: questionIds.Solvents,
        questionText: "Solvents",
    },
    {
        id: questionIds.RegularHandWashing,
        questionText: "Regular Hand Washing",
    },
    {
        id: questionIds.LaboratoryChemicals,
        questionText: "Laboratory chemicals",
    },
    {
        id: questionIds.CleaningMaterials,
        questionText: "Cleaning materials",
    },
    {
        id: questionIds.OrganicChemicals,
        questionText: "Organic chemicals",
    },
    {
        id: questionIds.EpoxyResins,
        questionText: "Epoxy resins",
    },
    {
        id: questionIds.Latex,
        questionText: "Latex",
    },
    {
        id: questionIds.StrongAcidsAlkalis,
        questionText: "Strong acids and alkalis",
    },
    {
        id: questionIds.SkinSymptomsDetails,
        questionText: "If applicable please detail when did the symptoms begin and where do they affect you?",
    },
    {
        id: questionIds.HasJobCausedWorsedSkinCondition,
        questionText: "Do you think that your job has caused or worsened any skin condition you have had?",
    },
    {
        id: questionIds.HasJobCausedWorsedSkinConditionFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.HadTreatmentForSkinCondition,
        questionText: "Have you had any treatment for a skin condition?",
    },
    {
        id: questionIds.HadTreatmentForSkinConditionFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.SeenDoctorSkinProblem,
        questionText: "Have you ever seen a doctor (GP, Consultant, OHP) about a skin problem?",
    },
    {
        id: questionIds.SeenDoctorSkinProblemFurtherDetails,
        questionText: "Please provide details",
    }
];
